<template>
  <v-ons-page modifier="secondary">
    <div class="background" />
    <div class="content">
      <map-component />
    </div>

    <!-- NOTE: Spot, Thingの自動更新をする -->
    <automatic-area-updater />
  </v-ons-page>
</template>

<script>
import mapComponent from './map.vue';
import automaticAreaUpdater from './partials/automatic_area_updater.vue';


export default {
  components: {
    mapComponent,
    automaticAreaUpdater,
  },
};
</script>

<style scoped lang="scss">
.background {
  background: #dbdcdc;
}
.content {
  overflow: hidden;
  top: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?d69dc0cc